import React, { useCallback } from 'react'

import PropTypes from 'prop-types'

import SegmentSelector, { UserTypeSelector } from 'components/SegmentSelector'

const WrappedUserTypeSelector = ({ trigger, segment, onUpdate }) => {
  const updateSegment = useCallback(
    (segment) => {
      onUpdate('Segment', segment)
    },
    [onUpdate],
  )
  return (
    <SegmentSelector
      trigger={trigger}
      segment={segment}
      onChange={updateSegment}
    >
      <UserTypeSelector trigger={trigger} />
    </SegmentSelector>
  )
}

WrappedUserTypeSelector.propTypes = {
  trigger: PropTypes.string,
  segment: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
}

export default WrappedUserTypeSelector
